// extracted by mini-css-extract-plugin
export default {"ListItemTitle_0":"HistorySummaryPage-module__ListItemTitle_0--kH6Mt"};